import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100vh',
    background: '#F2F1F1',
    overflowX: 'hidden',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'center',
    marginTop: '31vh',
  },
  container: {
    width: '90%',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    paddingBottom: 40,
  },
  actionsBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  refreshBadge: {
    fontSize: 12,
    color: '#026894',
    fontWeight: 'bold',
  },
  errorBox: {
    padding: '10px 14px',
    background: '#F2DEDE',
    color: '#A94442',
    border: '1px solid #EBCCD1',
    borderRadius: 4,
    fontSize: 13,
  },
  section: {
    background: '#fff',
    borderRadius: 6,
    padding: 16,
    boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
  },
  sectionTitle: {
    fontSize: 15,
    fontWeight: 'bold',
    color: '#232d64',
    marginBottom: 12,
    borderBottom: '2px solid #232d64',
    paddingBottom: 6,
  },
  countsGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
  },
  countChip: {
    padding: '8px 14px',
    borderRadius: 20,
    fontSize: 13,
    fontWeight: 'bold',
    color: '#fff',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: 13,
  },
  th: {
    textAlign: 'left',
    padding: '8px 10px',
    background: '#F5F5F5',
    borderBottom: '2px solid #ddd',
    fontWeight: 'bold',
    color: '#333',
  },
  td: {
    padding: '8px 10px',
    borderBottom: '1px solid #eee',
    verticalAlign: 'top',
  },
  monoSmall: {
    fontFamily: 'monospace',
    fontSize: 11,
    color: '#666',
    wordBreak: 'break-all',
  },
  stateChip: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: 10,
    fontSize: 11,
    fontWeight: 'bold',
    color: '#fff',
  },
  detailBtn: {
    background: 'none',
    border: '1px solid #026894',
    color: '#026894',
    padding: '4px 10px',
    borderRadius: 4,
    cursor: 'pointer',
    fontSize: 12,
  },
  modalBackdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  modalContent: {
    background: '#fff',
    borderRadius: 6,
    padding: 20,
    maxWidth: '80vw',
    maxHeight: '80vh',
    overflow: 'auto',
    width: 900,
  },
  modalTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 12,
    color: '#232d64',
  },
  preBlock: {
    background: '#F5F5F5',
    padding: 12,
    borderRadius: 4,
    fontSize: 11,
    fontFamily: 'monospace',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all',
    maxHeight: '60vh',
    overflow: 'auto',
  },
  closeBtn: {
    background: '#026894',
    color: '#fff',
    border: 'none',
    padding: '8px 16px',
    borderRadius: 4,
    cursor: 'pointer',
    fontSize: 13,
    marginTop: 12,
  },
}));

export default useStyles;
